export default {
  quote: {
    subtitle: "تسجيل المطعم",
    title1: "ابدأ مع",
    title2: "MAHAL",
    desc: "قم بتسجيل مطعمك لبدء التوريد من موردين موثوقين.",

    fullName: "الاسم الكامل",
    companyName: "اسم الشركة",
    selectCountry: "اختر الدولة",
    selectCity: "اختر المدينة",
    restaurant: "اسم المطعم",
    email: "البريد الإلكتروني",
    phone: "رقم الهاتف",

    uae: "الإمارات",
    india: "الهند",
    saudi: "السعودية",

    dubai: "دبي",
    abudhabi: "أبوظبي",
    sharjah: "الشارقة",

    restA: "مطعم أ",
    restB: "مطعم ب",

    cta: "متابعة →",
  },
};